import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import App from "./pages/App/App";
import { AuthComponent } from "./AuthComponent";
import appConfig from "./constants/config";
import { MsalProvider } from "@azure/msal-react";
import { AuthProvider } from "./components/AuthProvider/AuthProvider";
import { msalInstance } from "../src/constants/authConfig";
import QrCodeInstall from "./pages/QrCodeInstall/QrCodeInstall";
import MaintenancePage from "./pages/Maintenance/Maintenance";
import { loadRuntimeConfig } from "./constants/runtimeConfig";


interface IndexState {
  isAuth: boolean;
  isQrCode: boolean;
  isMaintenance : boolean;
}

class Index extends React.Component<{}, IndexState> {
  constructor(props: {}) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    const isMaintenance = window.location.pathname.includes('/maintenance');
    const isQrCode = urlParams.has("qrCode"); // Check for 'qrCode' param
    this.state = {
      isAuth: !!localStorage.getItem("ADUsername"),
      isQrCode,
      isMaintenance
    };
  }

  clearLocalStorage = () => {
    localStorage.clear();
  };

  handleAuthChange = (authParam: boolean) => {
    this.setState({ isAuth: authParam });
    console.log("The auth State: =============" + authParam);
  };

  render() {
    const { isAuth, isQrCode, isMaintenance } = this.state;

    return (
      <AuthProvider>
        <MsalProvider instance={msalInstance}>
          {isMaintenance ? (
            <MaintenancePage />
          ) : isQrCode ? (
            <QrCodeInstall /> // Render the special page if QR code is detected
          ) : appConfig.connectionString.DebugUserName === "" ? (
            isAuth ? (
              <App />
            ) : (
              <AuthComponent onAuthChange={this.handleAuthChange} />
            )
          ) : (
            <App />
          )}
        </MsalProvider>
      </AuthProvider>
    );
  }
}

// Load runtime config, then mount React
loadRuntimeConfig()
  .then(() => {
    // Create a root using ReactDOM.createRoot
    const root = ReactDOM.createRoot(document.getElementById("root")!);

    // Use the root to render your component
    root.render(<Index />);

    // Register service worker and handle updates with user prompt
    serviceWorkerRegistration.register({
  onUpdate: (registration: any) => {
    if (registration && registration.waiting) {
      // Prompt the user to refresh for new update
      // const userConsent = window.confirm(
      //   "A new version of the app is available. Would you like to update now?"
      // );
      //window.alert(`A new version of the app ${appConfig.Version.replace(/(\d+)(?!.*\d)/, (n) => (parseInt(n) + 1).toString())} is now available. The application will be refreshed to provide you with the latest updates.`);
      window.alert(`UPDATE : A new version of the app is now available. The application will be refreshed to provide you with the latest updates.`);
      // if (userConsent) {
      // Tell the new service worker to activate immediately
      registration.waiting.postMessage({ type: "SKIP_WAITING" });

      // Reload the page once the new service worker has activated
      registration.waiting.addEventListener("statechange", (event: any) => {
        if ((event.target as ServiceWorker).state === "activated") {
          window.location.reload();
        }
      });
      // }
    }
  },
});

    // Report web vitals
    reportWebVitals();
  })
  .catch((err) => {
    console.error("Failed to load runtime config:", err);
    // Render anyway with fallback values
    const root = ReactDOM.createRoot(document.getElementById("root")!);
    root.render(<Index />);
  });
